import ConnectSmartCar from './ConnectSmartCar'

export default ({ ...rest }) => <ConnectSmartCar {...rest} />
